var LineChartModule = /** @class */ (function () {
    function LineChartModule() {
    }
    return LineChartModule;
}());
export { LineChartModule };
